function IconSimplePerson({ fill, stroke }) {
  return (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 3.5C8 4.88071 6.88071 6 5.5 6C4.11929 6 3 4.88071 3 3.5C3 2.11929 4.11929 1 5.5 1C6.88071 1 8 2.11929 8 3.5ZM4.5 8H10V13H1V11.5C1 9.567 2.567 8 4.5 8Z" fill={fill} stroke={stroke} />
    </svg>
  )
}

export default IconSimplePerson